/**
 * Textes du connecteur Dropbox de la fiche dossier d'ouverture (ARTO-135) :
 * autoriser, coller le code, choisir le dossier, lancer, suivre, révoquer.
 * Fichier à part ; son bloc `connecteur` est fusionné dans le namespace
 * `console` (D15). Voix 2.2 : phrases courtes, un geste porte le même nom du
 * bouton au message de fin.
 */

export const frConnecteur = {
  importDropbox: {
    titre: 'Importer depuis une application',
    texte:
      'Reliez la galerie à son compte Dropbox. Artosera copie le dossier choisi dans un dépôt, en lecture seule ; rien n’est écrit chez la galerie avant l’essai d’un lot.',
    chargement: 'Lecture de la connexion…',
    erreurLecture: 'Impossible de lire l’état de la connexion Dropbox.',
    indisponible: 'Connecteur Dropbox non configuré',
    indisponibleAide:
      'La clé d’application manque sur cette plateforme. Les dépôts de fichiers restent disponibles dans la fiche de la galerie.',
    sansGalerie: 'Créez d’abord la galerie de ce dossier : le connecteur dépose dans son stockage.',
    clos: 'Ce dossier est clos : le connecteur n’autorise plus et ne lance plus d’import.',
    simule: 'Mode simulé : aucun compte Dropbox réel n’est contacté, et tout code est accepté.',
    etapes: 'Les étapes de l’import',
    etatEtape: { fait: 'faite', courant: 'à faire maintenant', aVenir: 'à venir' },
    etats: {
      aucune: 'Non connecté',
      en_attente: 'En attente du code',
      autorisee: 'Connecté',
      revoquee: 'Accès révoqué',
      purgee: 'Connexion purgée',
    },
    autoriser: {
      titre: 'Autoriser Dropbox',
      texte:
        'La galerie, ou l’opérateur avec elle, se connecte à Dropbox et accorde la lecture de ses fichiers. Dropbox affiche ensuite un code, à coller à l’étape suivante.',
      bouton: 'Ouvrir Dropbox pour autoriser',
      rouvrir: 'Rouvrir Dropbox',
      nouvelle: 'Demander une nouvelle autorisation',
      expire: 'L’autorisation est valable 15 minutes, jusqu’à {{heure}}.',
      expiree: 'L’autorisation a expiré. Demandez-en une nouvelle.',
      sansAdresse:
        'L’adresse d’autorisation ne se réaffiche pas après un rechargement. Demandez-en une nouvelle.',
      revoquee: 'L’accès a été révoqué le {{date}}. Autorisez Dropbox de nouveau pour reprendre.',
      purgee: 'La connexion a été purgée le {{date}} : aucun accès ne subsiste.',
      fait: 'Connecté au compte {{compte}}, autorisé par {{par}} le {{date}}.',
      faitSansCompte: 'Connecté, autorisé par {{par}} le {{date}}.',
    },
    code: {
      titre: 'Coller le code',
      texte: 'Dropbox affiche un code une fois l’accès accordé. Collez-le ici.',
      champ: 'Code Dropbox',
      valider: 'Valider le code',
      fait: 'Code accepté.',
    },
    dossier: {
      titre: 'Choisir le dossier',
      texte: 'Artosera copie ce dossier avec tous ses sous-dossiers.',
      groupe: 'Dossier Dropbox à importer',
      tout: 'Tout le compte',
      toutAide: 'Tous les fichiers du compte Dropbox.',
      choisi: 'Dossier choisi : {{chemin}}',
      choisiTout: 'Dossier choisi : tout le compte',
      utiliser: 'Utiliser ce dossier',
      changer: 'Changer de dossier',
      garder: 'Garder le dossier',
      tronque: 'La liste est tronquée : seuls les premiers dossiers sont affichés.',
      chargement: 'Lecture des dossiers Dropbox…',
      aucun: 'Ce compte ne contient aucun dossier. Choisissez « Tout le compte ».',
      erreur: 'Impossible de lire les dossiers de Dropbox.',
      changerImpossible: 'Un import tourne : attendez sa fin pour changer de dossier.',
    },
    lancer: {
      titre: 'Choisir les natures et lancer',
      texte:
        'Cochez ce que le dossier contient. Seules les natures couvertes par le mandat de la galerie sont proposées.',
      natures: 'Natures importées',
      aucuneNature:
        'Le mandat de reprise ne couvre aucune nature. Posez-le d’abord dans l’onglet Reprise de la galerie.',
      lienMandat: 'Ouvrir la reprise de la galerie',
      plafond: 'Volume maximal du dépôt (Go)',
      plafondAide: 'L’import s’arrête quand le dépôt est plein.',
      lancer: 'Lancer l’import',
      relancer: 'Lancer un nouvel import',
      reprendre: 'Reprendre l’import',
      choisirNature: 'Cochez au moins une nature.',
      lance: 'Import lancé.',
      reprisDansDepot: 'Import relancé : il reprend là où il s’est arrêté, dans le même dépôt.',
    },
    suivi: {
      titre: 'Suivre l’import',
      etats: {
        en_attente: 'En attente',
        en_cours: 'En cours',
        termine: 'Terminé',
        plafond_atteint: 'Dépôt plein',
        abandonne: 'Abandonné',
        interrompu: 'Interrompu',
      },
      compteurs: {
        fichiers: 'Fichiers copiés',
        octets: 'Volume copié',
        dejaPresents: 'Déjà présents',
        ecartes: 'Écartés',
        enregistrements: 'Enregistrements',
      },
      lance: 'Lancé le {{date}}.',
      termine: 'Terminé le {{date}}.',
      progression: 'Copie en cours',
      enCours:
        'La copie continue en arrière-plan : vous pouvez quitter cette page, le suivi se met à jour tout seul.',
      enAttente:
        'L’import attend son tour dans la file : les travaux des galeries en service passent avant.',
      fini: 'Les fichiers sont dans le dépôt. Artosera en fait l’inventaire (antivirus, types de fichiers) ; ensuite, vous créez les lots de correspondance.',
      pleinDepot:
        'Le dépôt est plein : ce qui a été copié est utilisable. Un nouvel import ouvre un autre dépôt.',
      interrompu:
        'Le travail s’est arrêté avant la fin. Relancez-le : il reprend là où il s’est arrêté, dans le même dépôt.',
      abandonne: 'L’import est abandonné. Corrigez la cause, puis lancez un nouvel import.',
      raisons: {
        plafond_depasse: 'Le dépôt a atteint son plafond de volume.',
        trop_de_fichiers: 'Le dépôt a atteint son nombre maximal de fichiers.',
        mandat_retire: 'Le mandat de reprise a été retiré.',
        mandat_absent: 'Aucun mandat de reprise ne couvre les natures visées.',
        connexion_revoquee: 'L’accès à Dropbox a été révoqué.',
        connecteur_indisponible: 'Le connecteur Dropbox n’est pas configuré.',
        depot_ferme: 'Le dépôt de l’import n’accepte plus de fichiers.',
        jeton_illisible: 'Le jeton est illisible : révoquez l’accès, puis autorisez de nouveau.',
        autorisation_retiree: 'Dropbox a retiré son autorisation.',
        brute: 'Raison : {{code}}',
      },
      versDepot: 'Ouvrir le dépôt',
      versDepotAide: 'Vous y trouvez l’inventaire du dépôt, puis la correspondance des lots.',
    },
    revoquer: {
      bouton: 'Révoquer l’accès',
      titre: 'Révoquer l’accès à Dropbox ?',
      texte:
        'Artosera efface le jeton ici, puis demande à Dropbox de le retirer. Les fichiers déjà copiés restent dans le dépôt. Pour importer de nouveau, il faudra autoriser Dropbox une autre fois.',
      confirmer: 'Révoquer l’accès',
      annuler: 'Annuler',
      annulerAutorisation: 'Annuler l’autorisation',
      resultat: {
        titre: 'Accès révoqué',
        faite: 'Dropbox a retiré l’accès.',
        echec:
          'Le jeton est effacé ici, mais Dropbox n’a pas confirmé. Retirez l’accès depuis le compte Dropbox, dans Sécurité puis Applications connectées.',
        sans_objet: 'Il n’y avait plus d’accès à retirer chez Dropbox.',
      },
    },
    erreurs: {
      connecteur_indisponible: 'Le connecteur Dropbox n’est pas configuré sur cette plateforme.',
      galerie_absente: 'Créez d’abord la galerie de ce dossier.',
      deja_autorisee: 'Dropbox est déjà autorisé : révoquez d’abord l’accès.',
      code_refuse: 'Dropbox refuse ce code. Vérifiez-le, ou demandez une nouvelle autorisation.',
      autorisation_expiree:
        'L’autorisation a expiré, ou elle n’a pas été demandée. Demandez-en une nouvelle.',
      autorisation_concurrente: 'Une autre autorisation vient de commencer. Rechargez la page.',
      autorisation_retiree:
        'Dropbox a retiré son autorisation. Révoquez l’accès, puis autorisez de nouveau.',
      dossier_inconnu: 'Ce dossier n’est plus dans la liste de Dropbox. Relisez la liste.',
      import_en_cours: 'Un import tourne : attendez sa fin.',
      source_absente: 'Choisissez d’abord le dossier à importer.',
      connexion_non_autorisee: 'Autorisez d’abord l’accès à Dropbox.',
      connexion_modifiee: 'La connexion vient de changer. Rechargez la page.',
      jeton_illisible: 'Le jeton est illisible : révoquez l’accès, puis autorisez de nouveau.',
      reprise_close: 'La reprise de ce dossier est close : plus aucun import ne se lance.',
      connexion_purgee:
        'Cette connexion a été purgée avec les sources du dossier : elle ne se réautorise plus.',
      sources_echues:
        'Les sources de ce dossier ont passé leur échéance de purge : plus aucun import.',
      galerie_purgee: 'La galerie est en cours de purge : plus aucune écriture.',
      echec: 'Dropbox n’a pas répondu, ou a refusé la demande. Réessayez dans un moment.',
    },
  },
};

export const enConnecteur: typeof frConnecteur = {
  importDropbox: {
    titre: 'Import from an application',
    texte:
      'Link the gallery to its Dropbox account. Artosera copies the chosen folder into a drop, read-only; nothing is written to the gallery before a batch is rehearsed.',
    chargement: 'Reading the connection…',
    erreurLecture: 'Unable to read the state of the Dropbox connection.',
    indisponible: 'Dropbox connector not configured',
    indisponibleAide:
      'The application key is missing on this platform. File drops remain available in the gallery page.',
    sansGalerie: 'Create this file’s gallery first: the connector drops into its storage.',
    clos: 'This file is closed: the connector no longer authorises or starts imports.',
    simule: 'Simulated mode: no real Dropbox account is contacted, and any code is accepted.',
    etapes: 'Import steps',
    etatEtape: { fait: 'done', courant: 'to do now', aVenir: 'upcoming' },
    etats: {
      aucune: 'Not connected',
      en_attente: 'Waiting for the code',
      autorisee: 'Connected',
      revoquee: 'Access revoked',
      purgee: 'Connection purged',
    },
    autoriser: {
      titre: 'Authorise Dropbox',
      texte:
        'The gallery, or the operator with them, signs in to Dropbox and grants read access to its files. Dropbox then shows a code, to paste in the next step.',
      bouton: 'Open Dropbox to authorise',
      rouvrir: 'Reopen Dropbox',
      nouvelle: 'Request a new authorisation',
      expire: 'The authorisation is valid for 15 minutes, until {{heure}}.',
      expiree: 'The authorisation has expired. Request a new one.',
      sansAdresse:
        'The authorisation address is not shown again after a reload. Request a new one.',
      revoquee: 'Access was revoked on {{date}}. Authorise Dropbox again to resume.',
      purgee: 'The connection was purged on {{date}}: no access remains.',
      fait: 'Connected to account {{compte}}, authorised by {{par}} on {{date}}.',
      faitSansCompte: 'Connected, authorised by {{par}} on {{date}}.',
    },
    code: {
      titre: 'Paste the code',
      texte: 'Dropbox shows a code once access is granted. Paste it here.',
      champ: 'Dropbox code',
      valider: 'Confirm the code',
      fait: 'Code accepted.',
    },
    dossier: {
      titre: 'Choose the folder',
      texte: 'Artosera copies this folder with all its subfolders.',
      groupe: 'Dropbox folder to import',
      tout: 'The whole account',
      toutAide: 'Every file in the Dropbox account.',
      choisi: 'Chosen folder: {{chemin}}',
      choisiTout: 'Chosen folder: the whole account',
      utiliser: 'Use this folder',
      changer: 'Change folder',
      garder: 'Keep the folder',
      tronque: 'The list is truncated: only the first folders are shown.',
      chargement: 'Reading Dropbox folders…',
      aucun: 'This account has no folder. Choose “The whole account”.',
      erreur: 'Unable to read the Dropbox folders.',
      changerImpossible: 'An import is running: wait for it to finish before changing folder.',
    },
    lancer: {
      titre: 'Choose the kinds of data and start',
      texte:
        'Tick what the folder contains. Only the kinds covered by the gallery’s migration mandate are offered.',
      natures: 'Kinds of data imported',
      aucuneNature:
        'The migration mandate covers no kind of data. Set it first in the gallery’s Migration tab.',
      lienMandat: 'Open the gallery’s migration',
      plafond: 'Maximum drop size (GB)',
      plafondAide: 'The import stops when the drop is full.',
      lancer: 'Start the import',
      relancer: 'Start a new import',
      reprendre: 'Resume the import',
      choisirNature: 'Tick at least one kind of data.',
      lance: 'Import started.',
      reprisDansDepot: 'Import restarted: it resumes where it stopped, in the same drop.',
    },
    suivi: {
      titre: 'Follow the import',
      etats: {
        en_attente: 'Waiting',
        en_cours: 'Running',
        termine: 'Finished',
        plafond_atteint: 'Drop full',
        abandonne: 'Abandoned',
        interrompu: 'Interrupted',
      },
      compteurs: {
        fichiers: 'Files copied',
        octets: 'Size copied',
        dejaPresents: 'Already present',
        ecartes: 'Set aside',
        enregistrements: 'Records',
      },
      lance: 'Started on {{date}}.',
      termine: 'Finished on {{date}}.',
      progression: 'Copy in progress',
      enCours:
        'The copy continues in the background: you can leave this page, progress updates by itself.',
      enAttente: 'The import is waiting its turn in the queue: live galleries’ jobs go first.',
      fini: 'The files are in the drop. Artosera is inventorying them (antivirus, file types); then you create the matching batches.',
      pleinDepot: 'The drop is full: what was copied is usable. A new import opens another drop.',
      interrompu:
        'The job stopped before the end. Restart it: it resumes where it stopped, in the same drop.',
      abandonne: 'The import is abandoned. Fix the cause, then start a new import.',
      raisons: {
        plafond_depasse: 'The drop reached its size ceiling.',
        trop_de_fichiers: 'The drop reached its maximum number of files.',
        mandat_retire: 'The migration mandate was withdrawn.',
        mandat_absent: 'No migration mandate covers the targeted kinds of data.',
        connexion_revoquee: 'Access to Dropbox was revoked.',
        connecteur_indisponible: 'The Dropbox connector is not configured.',
        depot_ferme: 'The import’s drop no longer accepts files.',
        jeton_illisible: 'The token is unreadable: revoke access, then authorise again.',
        autorisation_retiree: 'Dropbox withdrew its authorisation.',
        brute: 'Reason: {{code}}',
      },
      versDepot: 'Open the drop',
      versDepotAide: 'You will find the drop inventory there, then the matching of batches.',
    },
    revoquer: {
      bouton: 'Revoke access',
      titre: 'Revoke access to Dropbox?',
      texte:
        'Artosera erases the token here, then asks Dropbox to withdraw it. Files already copied stay in the drop. To import again, Dropbox will have to be authorised once more.',
      confirmer: 'Revoke access',
      annuler: 'Cancel',
      annulerAutorisation: 'Cancel the authorisation',
      resultat: {
        titre: 'Access revoked',
        faite: 'Dropbox withdrew the access.',
        echec:
          'The token is erased here, but Dropbox did not confirm. Remove the access from the Dropbox account, under Security then Connected apps.',
        sans_objet: 'There was no access left to withdraw at Dropbox.',
      },
    },
    erreurs: {
      connecteur_indisponible: 'The Dropbox connector is not configured on this platform.',
      galerie_absente: 'Create this file’s gallery first.',
      deja_autorisee: 'Dropbox is already authorised: revoke access first.',
      code_refuse: 'Dropbox rejects this code. Check it, or request a new authorisation.',
      autorisation_expiree:
        'The authorisation has expired, or was never requested. Request a new one.',
      autorisation_concurrente: 'Another authorisation has just started. Reload the page.',
      autorisation_retiree:
        'Dropbox withdrew its authorisation. Revoke access, then authorise again.',
      dossier_inconnu: 'This folder is no longer in Dropbox’s list. Read the list again.',
      import_en_cours: 'An import is running: wait for it to finish.',
      source_absente: 'Choose the folder to import first.',
      connexion_non_autorisee: 'Authorise access to Dropbox first.',
      connexion_modifiee: 'The connection has just changed. Reload the page.',
      jeton_illisible: 'The token is unreadable: revoke access, then authorise again.',
      reprise_close: 'This file’s migration is closed: no more imports can start.',
      connexion_purgee:
        'This connection was purged with the file’s sources: it can no longer be re-authorised.',
      sources_echues: 'This file’s sources are past their purge date: no more imports.',
      galerie_purgee: 'The gallery is being purged: no more writes.',
      echec: 'Dropbox did not answer, or refused the request. Try again in a moment.',
    },
  },
};
